import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import LiveCamera from "./components/livecamera";
// import React, { useRef, useState } from "react";
import Webcam from "react-webcam";

const Requisition = () => {
  const webcamRefs = useRef([]);
  const [capturedImages, setCapturedImages] = useState([]);
  const [webcamRow, setWebcamRow] = useState(null);
  const [currentFacingMode, setCurrentFacingMode] = useState("user");

  const captureImage = async (itemId) => {
    const webcamInstance = webcamRefs.current[itemId]?.current;
    const imageSrc = webcamInstance?.getScreenshot();
    if (!imageSrc) return;
    setCapturedImages((prev) => ({ ...prev, [itemId]: imageSrc }));
    try {
      const blob = await fetch(imageSrc).then((res) => res.blob());
      const file = new File([blob], `image_${itemId}.jpg`, {
        type: "image/jpeg",
      });
      const formData = new FormData();
      formData.append("file", file);
      formData.append("itemids", itemId);

      const response = await fetch(
        "https://ims-backend.indevconsultancy.in/api/uploadphoto/",
        {
          method: "POST",
          body: formData,
        }
      );

      if (!response.ok) {
        const errorData = await response.json();
        if (response.status === 401) {
          console.error("User not authenticated");
          window.location.href = "/login";
          return;
        }
        throw new Error(errorData.message || "Upload failed");
      }

      const result = await response.json();

      console.log("Image uploaded successfully:", result);
    } catch (error) {
      console.error("Upload error:", error);
      alert(error.message || "Failed to upload image");
    } finally {
      setWebcamRow(null);
      setCurrentFacingMode("user");
    }
  };

  const removeImage = (index) => {
    setCapturedImages([]);
    setCapturedImagesPanding([]);
  };

  const [stockItems, setStockItems] = useState([]);
  const [kitchenId, setKitchenId] = useState(null);
  const [requisitionList, setRequisitionList] = useState([]);
  const [formData, setFormData] = useState({ itemName: "", quantity: "" });
  const today = new Date().toISOString().split("T")[0];

  const [inputGroups, setInputGroups] = useState([
    {
      item: "",
      available: "",
      quantity: "",
      date: today,
      category_item: "",
      vendor_id: "",
    },
  ]);

  const [selectedItemId, setSelectedItemId] = useState(null);
  const [REID, setSelectedREID] = useState("");
  const [REID1, setSelectedREID1] = useState("");
  const [itemDetails, setItemDetails] = useState([]);
  const [stockOptions, setStockOptions] = useState([]);
  const [stockCategory, setCategory] = useState([]);
  const [stockVendor, setvendor] = useState([]);
  const [filterDate, setFilterDate] = useState("");
  const [filterRequisitionDate, setRequisitionDate] = useState("");

  const [inputrecievedata, setinputrecievedata] = useState([
    { receivedQuantity: "" }, // One object per row
  ]);

  // Pagination
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const totalPages = Math.ceil(requisitionList.length / itemsPerPage);
  const paginatedList = requisitionList.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user"));
    if (user?.kitchen) {
      setKitchenId(user.kitchen);
      axios
        .get(
          `https://ims-backend.indevconsultancy.in/api/kitchen-stock-reports/by-kitchen/${user.kitchen}/`
        )
        .then((res) => {
          const formatted = res.data.map((item) => ({
            kitchenstock_id: item.kitchenstock_id,
            stock_name: item.stock_name,
            quantity: item.quantity,
            required_quantity: "",
            required_date: "",
          }));
          setStockItems(formatted);
        })
        .catch((err) => console.error("Error fetching kitchen stock:", err));
    }
  }, []);

  useEffect(() => {
    fetchRequisitionList();
  }, []);

  useEffect(() => {
    axios
      .get("https://ims-backend.indevconsultancy.in/admin-panel/vendor/")
      .then((res) => setvendor(res.data))
      .catch((err) => console.error("Error fetching stock options:", err));
  }, []);

  const stocksItem = (categoryId, index) => {

    const user = JSON.parse(localStorage.getItem("user"));
    if (user?.kitchen) {
      axios.get(`https://ims-backend.indevconsultancy.in/api/itemlist/?categoryid=${categoryId}&kitchenid=${user.kitchen}`)
        // .get(
        //   `https://ims-backend.indevconsultancy.in/api/stocks/?category_id=${categoryId}`
        // )
        .then((res) => {
          const updatedStockOptions = [...stockOptions];
          updatedStockOptions[index] = res.data;
          setStockOptions(updatedStockOptions);
        })
        .catch((err) => console.error("Error fetching stock options:", err));
    }
  };

  useEffect(() => {
    axios
      .get("https://ims-backend.indevconsultancy.in/admin-panel/category/")
      .then((res) => setCategory(res.data))
      .catch((err) => console.error("Error fetching stock options:", err));
  }, []);

  const statusMap = {
    0: "Request",
    1: "Approved",
    2: "Recieved",
    3: "Pending",
    4: "Delete",
  };
  const statusColorMap = {
    0: "secondary",
    1: "warning",
    2: "success",
    3: "warning",
    4: "danger",
  };

  const fetchRequisitionItemDetails = async (pk) => {
    try {
      const response = await axios.get(
        `https://ims-backend.indevconsultancy.in/api/item-request-list/${pk}/`
      );
      setItemDetails(response.data.requisitiondataitem);
    } catch (error) {
      console.error("Error fetching item details:", error);
    }
  };

  const [formErrors, setFormErrors] = useState([]);
  // const [avilablequantiy, setavilablequantity] = useState('');
  const handleSubmit = async (e) => {
    e.preventDefault();

    let isValid = true;
    let errorMessages = [];

    inputGroups.forEach((group, index) => {
      if (!group.date) {
        isValid = false;
        errorMessages.push(
          `Row ${index + 1}: Please select the Date of Received.`
        );
      }
      if (!group.item) {
        isValid = false;
        errorMessages.push(`Row ${index + 1}: Item name is required.`);
      }
      if (!group.quantity) {
        isValid = false;
        errorMessages.push(
          `Row ${index + 1}: Quantity must be greater than 0.`
        );
      }
      if (!group.category_item) {
        isValid = false;
        errorMessages.push(`Row ${index + 1}: Category is required.`);
      }
    });
    if (!isValid) {
      setFormErrors(errorMessages);
      return;
    } else {
      setFormErrors([]);
    }
    try {
      const response = await axios.post(
        "https://ims-backend.indevconsultancy.in/api/add-request-items",
        {
          items: inputGroups.map((group) => ({
            item: group.item,
            quantity: group.quantity,
            kitchenId: kitchenId,
            available: "",
            date: group.date,
            category: group.category_item,
            vendor_id: group.vendor_id,
          })),
        }
      );

      if (response.status === 200 || response.status === 201) {
        setInputGroups([
          {
            item: "",
            available: 100,
            quantity: "",
            date: today,
            category_item: "",
            vendor_id: "",
          },
        ]);
        fetchRequisitionList();
        const modalEl = document.getElementById("registerModal");
        const modal = bootstrap.Modal.getInstance(modalEl);
        modal.hide();
      } else {
        alert("Failed to save items");
      }
    } catch (error) {
      console.error("API error:", error);
      alert("An error occurred while saving data");
    }
  };

  const handleSearch = (e) => {
    e.preventDefault();
    if (filterRequisitionDate || filterDate) {
      fetchRequisitionList(filterRequisitionDate, filterDate);
    } else {
      fetchRequisitionList();
    }
  };

  const addInputGroup = () => {
    setInputGroups([
      ...inputGroups,
      {
        item: "",
        available: "",
        quantity: "",
        date: today,
        category_item: "",
      },
    ]);
  };

  const removeInputGroup = (index) => {
    const updated = [...inputGroups];
    updated.splice(index, 1);
    setInputGroups(updated);
  };

  const handleInputChange = (index, field, value, totalcount) => {
    const updated = [...inputGroups];
    updated[index][field] = value;

    // const availableQty = selectedOption.getAttribute('data-availablequantity');
    if (totalcount !== undefined) {
      updated[index].available = totalcount;
    }
    setInputGroups(updated);
    // setavilablequantity(totalcount);
    console.log(totalcount, 'sdfdsf');
    // setavilablequantity(availableQty);
  };

  const fetchRequisitionList = (date = "", status = "") => {
    const user = JSON.parse(localStorage.getItem("user"));
    if (user?.kitchen) {
      let url = `https://ims-backend.indevconsultancy.in/api/requistion-list/?kitchen_id=${user?.kitchen}`;
      const params = [];
      if (date) params.push(`date=${encodeURIComponent(date)}`);
      if (status) params.push(`status=${encodeURIComponent(status)}`);
      if (params.length > 0) {
        url += `&${params.join("&")}`;
      }
      axios
        .get(url)
        .then((response) => {
          if (response.data.requisitiondata) {
            // ✅ Filter out deleted items (status === 4)
            const filteredData = response.data.requisitiondata.filter(
              (item) => item.status !== 4
            );

            // ✅ Set filtered data
            setRequisitionList(filteredData);
            setCurrentPage(1);
          }
        })
        .catch((error) =>
          console.error("Failed to fetch requisition list:", error)
        );
    }
  };

  const [itemDetailsSaveData, setItemDetailsSaveData] = useState([]);
  const [selectedVendorId, setSelectedVendorId] = useState("");
  const [selectedDateofReceived, setSelectedDateofReceived] = useState("");

  useEffect(() => {
    const today = new Date().toISOString().split("T")[0]; // Formats as 'YYYY-MM-DD'
    setSelectedDateofReceived(today);
  }, []);

  const handleInputChangeMRN = (index, field, value) => {
    const updatedDetails = [...itemDetails];
    console.log(updatedDetails);
    updatedDetails[index][field] = value;
    setItemDetailsSaveData(updatedDetails);
    // setavilablequantity(value);
  };

  const handleSubmitMRN = async () => {
    try {
      const payload = {
        requisition_id: REID1,
        date_of_order: selectedDateofReceived,
        vendor_id: selectedVendorId,
        items: itemDetailsSaveData,
      };
      const response = await axios.post(
        "https://ims-backend.indevconsultancy.in/api/sumit-request-items",
        payload
      );
      fetchRequisitionList();
    } catch (error) {
      console.error("Submission failed:", error);
      alert("Error submitting requisition");
    }
  };

  const handlereceivedvalue = (index, field, value) => {
    const updatedGroups = [...inputrecievedata];
    if (!updatedGroups[index]) {
      updatedGroups[index] = {};
    }
    const parsedValue = Number(value);
    updatedGroups[index][field] = isNaN(parsedValue) ? 0 : parsedValue;

    if (itemDetails[index]) {
      updatedGroups[index].itemid = itemDetails[index].id;
      updatedGroups[index].kitchenid = kitchenId;
      // updatedGroups[index].stock_id = kitchenId;
    }

    setinputrecievedata(updatedGroups);
  };

  useEffect(() => {
    if (itemDetails.length > 0) {
      const initialData = itemDetails.map(() => ({ recivedquantity: "" }));
      setinputrecievedata(itemDetails);
    }
  }, [itemDetails]);

  const submitrecievedata = async () => {
    try {
      const response = await axios.post(
        "https://ims-backend.indevconsultancy.in/api/recivequantity/",
        inputrecievedata,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      setWebcamRow(null);
      setCapturedImages([]);
      setCurrentFacingMode("user");
      fetchRequisitionList();
    } catch {
      console.log("something went wrond");
    }
  };
  const [formErrorPanding, setFormErrorPanding] = useState("");


  const [getPandingValue, setPandingValue] = useState([]);
  const [getPandingValueUpdate, setPandingValueUpdate] = useState([]);
  const [formError, setFormError] = useState("");

  const pandingValueRecevi = async (pk) => {
    try {
      const response = await axios.get(
        `https://ims-backend.indevconsultancy.in/api/item-request-list/${pk}/`
      );
      setPandingValue(response.data.requisitiondataitem);
      setPandingValueUpdate(response.data.requisitiondataitem);
    } catch (error) {
      console.error("Error fetching item details:", error);
    }
  };

  const handleReceivedQuantityChange = (index, value) => {
    const numericValue = Number(value);

    const updated = getPandingValueUpdate.map((item, i) =>
      i === index
        ? { ...item, pendingquantity: isNaN(numericValue) ? 0 : numericValue }
        : item
    );

    setPandingValueUpdate(updated);
  };

  useEffect(() => {
    console.log("Original:", getPandingValue);
    console.log("Updated:", getPandingValueUpdate);
  }, [getPandingValueUpdate]);

  const [receivedQuantities, setReceivedQuantities] = useState({});

  useEffect(() => {
    [...getPandingValue, ...itemDetails].forEach((item) => {
      if (!webcamRefs.current[item.id]) {
        webcamRefs.current[item.id] = React.createRef();
      }
    });
  }, [getPandingValue, itemDetails]);

  const handleQtyChange = (index, id, value) => {
    handleReceivedQuantityChange(index, value);
    setReceivedQuantities((prev) => ({
      ...prev,
      [id]: value,
    }));
  };

  const webcamRefsPanding = useRef({});
  const [capturedImagesPanding, setCapturedImagesPanding] = useState({});
  const [webcamRowPanding, setWebcamRowPanding] = useState(null);
  const [currentFacingModePanding, setCurrentFacingModePanding] = useState("user");

  const videoConstraints = {
    facingMode: currentFacingModePanding,
  };

  const captureImagePanding = (itemId) => {
    const webcamInstance = webcamRefsPanding.current[itemId];
    const imageSrc = webcamInstance?.getScreenshot();
    if (!imageSrc) return;
    setCapturedImagesPanding((prev) => ({ ...prev, [itemId]: imageSrc }));
  };

  const removeImagePanding = (itemId) => {
    setCapturedImagesPanding((prev) => {
      const updated = { ...prev };
      delete updated[itemId];
      return updated;
    });
  };

  const toggleFacingModePanding = () => {
    setCurrentFacingModePanding((prevMode) =>
      prevMode === "user" ? "environment" : "user"
    );
  };
  const submitPandingValue = async () => {
    const user = JSON.parse(localStorage.getItem("user"));
    if (!user?.kitchen) {
      setFormErrorPanding("Kitchen ID not found.");
      return;
    }

    try {
      const payload = getPandingValueUpdate.map((item) => ({
        pendingquantity: isNaN(Number(item.pendingquantity)) ? 0 : Number(item.pendingquantity),
        stock_id: item.stock_id,
        item_request_id: item.id,
        kitchen_id: user.kitchen,
        vendor_id: item.vendor_id,
        image: capturedImagesPanding[item.id] || null,
      }));


      const response = await axios.post(
        "https://ims-backend.indevconsultancy.in/api/pendingquantity/",
        payload
      );

      if (response.status === 200) {
        fetchRequisitionList();
        setWebcamRowPanding(null);
        setCapturedImagesPanding({});
        setCurrentFacingModePanding("user");
        setFormErrorPanding("");
      }
    } catch (error) {
      console.error("Submission failed:", error);
      setFormErrorPanding("Failed to submit. Please try again.");
    }
  };

  const [getPandingDataShow, setPandingDataShow] = useState([]);

  const getPanding = async (pk) => {
    try {
      const response = await axios.get(
        `https://ims-backend.indevconsultancy.in/api/pendingquantity/?requistion_id=${pk}`
      );
      setPandingDataShow(response.data || []);
    } catch (error) {
      console.error("Error fetching item details:", error);
    }
  };

  return (
    <div className="container-fluid px-2">
      <div className="content">
        <div className="container-fluid">
          <div className="row align-items-center justify-content-between py-2">
            <div className="col-md-6 col-6">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb justify-content-start mb-0">
                  <li className="breadcrumb-item">
                    <Link to="/mobilehome">Home</Link>
                  </li>
                </ol>
              </nav>
            </div>
            <div className="col-md-6 col-6 text-end">
              <span className="fs-1">Requisition List</span>
            </div>
          </div>

          <div className="row g-3">
            <div className="col-md-12">
              <div className="card">
                <div className="card-header border-info">
                  <form onSubmit={handleSearch}>
                    <div className="row g-3">
                      <div className="col-lg">
                        <select
                          className="form-control"
                          value={filterDate}
                          onChange={(e) => setFilterDate(e.target.value)}
                        >
                          <option value="">Select Status</option>
                          <option value="0">Pending</option>
                          <option value="1">Received</option>
                          <option value="2">Delivery</option>
                          <option value="4">Delete</option>
                        </select>
                      </div>
                      <div className="col-lg">
                        <input
                          type="date"
                          className="form-control"
                          value={filterRequisitionDate}
                          onChange={(e) => setRequisitionDate(e.target.value)}
                        />
                      </div>

                      <div className="col-lg-2">
                        <button type="submit" className="btn btn-primary w-100">
                          Search
                        </button>
                      </div>
                      <div className="col-lg-1">
                        <button
                          type="button"
                          className="btn btn-outline-dark w-100"
                          onClick={() => {
                            setFilterDate("");
                            fetchRequisitionList();
                          }}
                        >
                          Reset
                        </button>
                      </div>
                    </div>
                  </form>
                </div>

                <div className="card-body">
                  <div className="row g-0 align-items-center">
                    <div className="col-sm-7 mb-3">
                      <h6 className="fw-bold mb-0">
                        Total Requisition(s):{" "}
                        <span>{requisitionList.length}</span>
                      </h6>
                    </div>
                    <div className="col-sm-5 mb-3 text-end">
                      <button
                        className="btn btn-primary add-item"
                        type="button"
                        data-bs-toggle="modal"
                        data-bs-target="#registerModal"
                      >
                        Add <i className="fas fa-plus"></i>
                      </button>
                    </div>
                  </div>

                  <div className="table-responsive scrollbar">
                    <table className="table text-center table-bordered table-striped fs--1 mb-0">
                      <thead className="bg-primary text-white">
                        <tr>
                          <th>S.No.</th>
                          <th>Requisition ID</th>
                          <th>Date</th>
                          <th>Status</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {paginatedList.length === 0 ? (
                          <tr>
                            <td colSpan="5">Loading or no data available</td>
                          </tr>
                        ) : (
                          paginatedList.map((item, index) => {
                            return (
                              <tr key={item.pk}>
                                <td>
                                  {(currentPage - 1) * itemsPerPage + index + 1}
                                </td>
                                <td>RE00{item.reqid || item.reqid}</td>
                                <td>
                                  {new Date(
                                    item.requestdate
                                  ).toLocaleDateString()}
                                </td>
                                <td>
                                  <span
                                    className={`badge bg-${statusColorMap[item.status] || "dark"
                                      }`}
                                  >
                                    {statusMap[item.status] || "Unknown"}
                                  </span>
                                </td>
                                <td>
                                  {item.status != "4" && (

                                    <div className="d-flex gap-2 justify-content-center">
                                      <button
                                        className="btn btn-primary add-item btn-sm"
                                        type="button"
                                        data-bs-toggle="modal"
                                        data-bs-target="#viweModal"
                                        onClick={() => {
                                          setSelectedItemId(item.reqid);
                                          fetchRequisitionItemDetails(item.reqid);
                                          removeImage();
                                        }}
                                        title="View"
                                      >
                                        View <i className="fas fa-eye"></i>
                                      </button>
                                      <button
                                        className="btn btn-secondary add-item btn-sm"
                                        type="button"
                                        data-bs-toggle="modal"
                                        data-bs-target="#showPandingData"
                                        onClick={() => {
                                          setSelectedItemId(item.reqid);
                                          removeImage();
                                          getPanding(item.reqid);
                                        }}
                                        title="Pending View"
                                      >
                                        Pending <i className="fas fa-eye"></i>
                                      </button>

                                      {/* <button
                                        className="btn add-item btn-sm text-white"
                                        style={{ background: "#8b1a1a" }}
                                        type="button"
                                        title="Data Delete"
                                      >
                                        <i className="fas fa-trash"></i>
                                      </button> */}

                                      {item.status == "3" && (
                                        <button
                                          className="btn btn-primary add-item btn-sm"
                                          type="button"
                                          data-bs-toggle="modal"
                                          data-bs-target="#editModal"
                                          onClick={() => {
                                            setSelectedREID("RE00" + item.reqid);
                                            setSelectedREID1(item.reqid);
                                            setSelectedItemId(item.reqid);
                                            pandingValueRecevi(item.reqid);
                                            removeImage();
                                          }}
                                          title="Edit"
                                        >
                                          Pending Received
                                        </button>
                                      )}
                                    </div>
                                  )}

                                </td>
                              </tr>
                            );
                          })
                        )}
                      </tbody>
                    </table>
                  </div>

                  {/* {paginatedList.length > 10 && ( */}
                  <div className="d-flex justify-content-between align-items-center mt-3">
                    <button
                      className="btn btn-outline-primary btn-sm"
                      onClick={() =>
                        setCurrentPage((prev) => Math.max(prev - 1, 1))
                      }
                      disabled={currentPage === 1}
                    >
                      Previous
                    </button>
                    <span>
                      Page {currentPage} of {totalPages}
                    </span>
                    <button
                      className="btn btn-outline-primary btn-sm"
                      onClick={() =>
                        setCurrentPage((prev) => Math.min(prev + 1, totalPages))
                      }
                      disabled={currentPage === totalPages}
                    >
                      Next
                    </button>
                  </div>
                  {/* )} */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ========== ADD Requisition MODAL ========== */}
      <div
        className="modal fade"
        id="registerModal"
        tabIndex="-1"
        aria-labelledby="registerModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-xl">
          <div className="modal-content">
            <form onSubmit={handleSubmit}>
              <div className="modal-header">
                <h5 className="modal-title" id="registerModalLabel">
                  {" "}
                  Add Requisition Item{" "}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body">
                {formErrors.length > 0 && (
                  <div className="alert alert-danger">
                    <ul>
                      {formErrors.map((msg, i) => (
                        <li key={i}>{msg}</li>
                      ))}
                    </ul>
                  </div>
                )}
                {inputGroups.map((group, index) => (
                  <div className="row g-2 mb-3" key={index}>
                    <div className="col-12 col-md-2">
                      <select
                        className="form-control"
                        name="category_item[]"
                        value={group.category_item}
                        onChange={(e) => {
                          const selectedCategoryId = e.target.value;
                          handleInputChange(
                            index,
                            "category_item",
                            selectedCategoryId
                          );
                          stocksItem(selectedCategoryId, index);
                        }}
                      >
                        <option value="">Select Category</option>
                        {stockCategory.map((category) => (
                          <option
                            key={category.category_id}
                            value={category.category_id}
                          >
                            {category.category_name}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="col-12 col-md-2">
                      <select
                        className="form-control"
                        name="item[]"
                        value={group.item}
                        onChange={(e) => {
                          const selectedOption = e.target.selectedOptions[0];
                          const availableQty = selectedOption.getAttribute('data-availablequantity');
                          handleInputChange(index, "item", e.target.value, availableQty);
                          handleInputChange(index, "vendor_id", 0, availableQty);
                        }}
                      >
                        <option value="">Select Item</option>
                        {(Array.isArray(stockOptions[index])
                          ? stockOptions[index]
                          : []
                        ).map((item) => (
                          <option key={item.stock_id} value={item.stock_id} data-availablequantity={item.total_quantity}>
                            {item.stock_name} ({item.units}) - Available Quantity: {item.total_quantity}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="col-6 col-md-2">
                      <input
                        type="number"
                        onWheel={(e) => e.target.blur()}
                        className="form-control"
                        placeholder="Avilable Quantity"
                        value={group.available || ""}
                        readOnly
                      />
                    </div>
                    <div className="col-6 col-md-2">
                      <input
                        type="number"
                        onWheel={(e) => e.target.blur()}
                        className="form-control"
                        placeholder="Quantity"
                        value={group.quantity}
                        onChange={(e) =>
                          handleInputChange(index, "quantity", e.target.value)
                        }
                      />
                    </div>

                    <div className="col-6 col-md-2">
                      <input
                        type="date"
                        className="form-control"
                        value={group.date}
                        onChange={(e) =>
                          handleInputChange(index, "date", e.target.value)
                        }
                      />
                    </div>

                    <div className="col-12 col-md-2 d-flex align-items-center">
                      {index === 0 ? (
                        <button
                          className="btn btn-success w-100"
                          type="button"
                          onClick={addInputGroup}
                        >
                          <i className="fas fa-plus"></i>
                        </button>
                      ) : (
                        <button
                          className="btn btn-danger w-100"
                          type="button"
                          onClick={() => removeInputGroup(index)}
                        >
                          <i className="fas fa-minus"></i>
                        </button>
                      )}
                    </div>
                  </div>
                ))}
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-bs-dismiss="modal"
                >
                  Close
                </button>
                <button type="submit" className="btn btn-primary">
                  Submit
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      {/* ========== EDIT MODAL ========== */}
      <div
        className="modal fade"
        id="editModal"
        tabIndex="-1"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-xl">
          <div className="modal-content">
            {/* Modal Header */}
            <div className="modal-header">
              <h5 className="modal-title">Pending Quantity Received</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
              />
            </div>

            {/* Modal Body */}
            <div className="modal-body px-2 px-md-4">
              {formErrorPanding && (
                <div className="alert alert-danger">{formErrorPanding}</div>
              )}

              {getPandingValue.length === 0 ? (
                <p>No items available</p>
              ) : (
                <div className="table-responsive">
                  <table className="table text-center table-bordered table-striped fs--1 mb-0">
                    <thead className="bg-primary text-white">
                      <tr>
                        <th>Category Name</th>
                        <th>Vendor Name</th>
                        <th>Item</th>
                        <th>Pending Quantity</th>
                        <th>Pending Received Quantity</th>
                        <th>Image</th>
                      </tr>
                    </thead>
                    <tbody>
                      {getPandingValue.map((item, index) =>
                        item.pendingquantity > 0 ? (
                          <tr key={item.id}>
                            <td>{item.category_name}</td>
                            <td>{item.vendor_name}</td>
                            <td>{item.stock}</td>
                            <td>{item.pendingquantity}</td>
                            <td>
                              <td className="text-center">
                                <div style={{ display: "inline-block" }}>
                                  <input
                                    type="number"
                                    className="form-control"
                                    onWheel={(e) => e.target.blur()}
                                    // placeholder="Pending Received Quantity"
                                    style={{
                                      minWidth:
                                        window.innerWidth <= 576
                                          ? "120px"
                                          : "auto",
                                    }}
                                    onChange={(e) =>
                                      handleQtyChange(
                                        index,
                                        item.id,
                                        e.target.value
                                      )
                                    }
                                  />
                                </div>
                              </td>
                            </td>
                            <td>
                              {capturedImagesPanding[item.id] ? (
                                <div>
                                  <img
                                    src={capturedImagesPanding[item.id]}
                                    alt="Captured"
                                    width={150}
                                    className="border rounded"
                                  />
                                  <button
                                    onClick={() => removeImagePanding(item.id)}
                                    className="btn btn-danger btn-sm ms-2"
                                  >
                                    Remove Image
                                  </button>
                                </div>
                              ) : (
                                <>
                                  {webcamRowPanding === item.id ? (
                                    <div>
                                      <Webcam
                                        audio={false}
                                        ref={(el) => (webcamRefsPanding.current[item.id] = el)}
                                        screenshotFormat="image/jpeg"
                                        videoConstraints={{ facingMode: currentFacingModePanding }}
                                        className="border rounded"
                                        width={150}
                                      />
                                      <div className="d-flex gap-2 mt-2">
                                        <button
                                          onClick={() => captureImagePanding(item.id)}
                                          className="btn btn-success btn-sm"
                                        >
                                          Capture
                                        </button>
                                        <button
                                          onClick={toggleFacingModePanding}
                                          className="btn btn-primary btn-sm"
                                        >
                                          Switch Camera
                                        </button>
                                        <button
                                          onClick={() => setWebcamRowPanding(null)}
                                          className="btn btn-secondary btn-sm"
                                        >
                                          Close
                                        </button>
                                      </div>
                                    </div>
                                  ) : (
                                    <button
                                      onClick={() => setWebcamRowPanding(item.id)}
                                      className="btn btn-warning btn-sm"
                                    >
                                      Open Camera
                                    </button>
                                  )}
                                </>
                              )}
                            </td>
                          </tr>
                        ) : null
                      )}
                    </tbody>
                  </table>
                </div>
              )}
            </div>

            {/* Modal Footer */}
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Close
              </button>
              <button
                type="button"
                className="btn btn-primary"
                data-bs-dismiss="modal"
                onClick={submitPandingValue}
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* ========== VIEW MODAL ========== */}
      <div
        className="modal fade"
        id="viweModal"
        tabIndex="-1"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-xl">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">View</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
              />
            </div>
            <div className="modal-body py-2">
              {itemDetails.length === 0 ? (
                <p className="text-center text-danger">No data found</p>
              ) : (
                <div className="table-responsive">
                  <table className="table text-center table-bordered table-striped fs--1 mb-0">
                    <thead className="bg-primary text-white">
                      <tr>
                        <th>S.No.</th>
                        <th>Category Name</th>
                        <th>Vendor Name</th>
                        <th>Item</th>
                        <th>Requested</th>
                        <th>Required Date</th>
                        <th>Approved</th>
                        <th>Approve Date</th>
                        <th>Received</th>
                        <th>Image</th>
                      </tr>
                    </thead>
                    <tbody>
                      {itemDetails.map((item, index) => (
                        <tr key={item.id}>
                          <td>{index + 1}</td>
                          <td>{item.category_name}</td>
                          <td>{item.vendor_name}</td>
                          <td>{item.stock}</td>
                          <td>{item.requestquantity}</td>
                          <td>
                            {new Date(item.required_date).toLocaleDateString()}
                          </td>
                          <td>{item.approve_quantity}</td>
                          <td>
                            {item.approve_date ? new Date(item.approve_date).toLocaleDateString() : ''}
                          </td>
                          <td>
                            {item.recieved_quantity !== "" && item.recieved_quantity != "0" ? (
                              item.recieved_quantity
                            ) : (
                              <input
                                type="number"
                                onWheel={(e) => e.target.blur()}
                                className="form-control"
                                style={{
                                  minWidth:
                                    window.innerWidth <= 576 ? "120px" : "auto",
                                }}
                                // value={
                                //   inputrecievedata[index]?.recivedquantity || ""
                                // }
                                onChange={(e) =>
                                  handlereceivedvalue(
                                    index,
                                    "recivedquantity",
                                    e.target.value
                                  )
                                }
                              />
                            )}
                          </td>
                          <td>
                            {item.recieved_quantity !== '' ? (
                              <img
                                src={item.imageurl}
                                alt="Captured"
                                className="img-thumbnail"
                                style={{
                                  width: "80px",
                                  height: "60px",
                                  objectFit: "cover",
                                }}
                              />
                            ) : webcamRow === item.id ? (
                              <div className="d-flex flex-column align-items-center gap-2">
                                <Webcam
                                  audio={false}
                                  ref={webcamRefs.current[item.id]}
                                  screenshotFormat="image/jpeg"
                                  className="rounded border"
                                  videoConstraints={{
                                    facingMode: currentFacingMode,
                                  }}
                                  style={{
                                    width: "150px",
                                    height: "100px",
                                    objectFit: "cover",
                                  }}
                                />
                                <div className="d-flex gap-2">
                                  <button
                                    className="btn btn-success btn-sm"
                                    onClick={() => captureImage(item.id)}
                                  >
                                    Capture
                                  </button>
                                  <button
                                    className="btn btn-info btn-sm"
                                    onClick={() =>
                                      setCurrentFacingMode((prev) =>
                                        prev === "user" ? "environment" : "user"
                                      )
                                    }
                                  >
                                    Switch Camera (
                                    {currentFacingMode === "user"
                                      ? "Front"
                                      : "Back"}
                                    )
                                  </button>
                                  <button
                                    className="btn btn-secondary btn-sm"
                                    onClick={() => {
                                      setWebcamRow(null);
                                      setCurrentFacingMode("user");
                                    }}
                                  >
                                    Cancel
                                  </button>
                                </div>
                              </div>
                            ) : capturedImages[item.id] ? (
                              <img
                                src={capturedImages[item.id]}
                                alt="Captured"
                                className="img-thumbnail"
                                style={{
                                  width: "80px",
                                  height: "60px",
                                  objectFit: "cover",
                                }}
                              />
                            ) : (
                              <button
                                className="btn btn-outline-primary btn-sm"
                                onClick={() => {
                                  setWebcamRow(item.id);
                                  setCurrentFacingMode("user");
                                }}
                              >
                                <i className="bi bi-camera"></i>
                              </button>
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Close
              </button>
              <button
                type="button"
                className="btn btn-primary"
                data-bs-dismiss="modal"
                onClick={submitrecievedata}
              >
                Save
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* ========== VIEW MODAL ========== */}
      <div
        className="modal fade"
        id="showPandingData"
        tabIndex="-1"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-xl">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Pending Quantity</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
              />
            </div>
            <div className="modal-body py-2">
              {getPandingDataShow.length === 0 ? (
                <p className="text-center text-danger">No data found</p>
              ) : (
                <div className="table-responsive">
                  <table className="table text-center table-bordered table-striped fs--1 mb-0">
                    <thead className="bg-primary text-white">
                      <tr>
                        <th>Item</th>
                        <th>Pending Quantity</th>
                        <th>Image</th>
                      </tr>
                    </thead>
                    <tbody>
                      {getPandingDataShow.map((item, index) => (
                        <tr key={item.id}>
                          <td>{item.itemname}</td>
                          <td>{item.pendingquantity}</td>
                          <td>
                            <img
                              src={item.imageurl}
                              alt="Captured"
                              className="img-thumbnail"
                              style={{
                                width: "80px",
                                height: "60px",
                                objectFit: "cover",
                              }}
                            />
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Close
              </button>
              <button
                type="button"
                className="btn btn-primary"
                data-bs-dismiss="modal"
              >
                Save
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Requisition;